var map = {
	"./_audio.png": "53fd",
	"./_pay.jpg": "ff22",
	"./_video.png": "2d9b",
	"./feedback.jpg": "4ba6",
	"./frame.png": "5996",
	"./pattern.svg": "f7e4",
	"./pay.jpg": "3f2b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";